import React, { useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import MasterDetailListShell from "../../../components/layout/MasterDetailListShell";
import MasterDetailRow from "../../../components/layout/MasterDetailRow";
import { useListGuardingEmployeesQuery, useListSupervisorAreasQuery } from "../guardingApi";
import { useBranchFilter } from "../../branchFilter/useBranchFilter";
import { paths } from "../../../routes/paths";

// Employee is the master entity here (not the assignment). The picker is
// server-filtered to the SUPERVISOR designation only (SupervisorAreaService.
// ListEmployeesForPickerAsync) - direct instruction, supersedes the original
// Phase 1 plan's softer badge-and-sort approach for "any employee." Each
// row's "Areas: N" badge doubles as the at-a-glance "who covers what"
// overview a separate summary table would otherwise have needed.
const SupervisorCompactList = () => {
  const navigate = useNavigate();
  const { employeeRecordGuid: selectedRecordGuid } = useParams();
  const [search, setSearch] = useState("");
  const { selectedBranchId } = useBranchFilter();

  const { data: employees = [], isLoading } = useListGuardingEmployeesQuery({
    branchId: selectedBranchId ?? undefined,
    search: search || undefined,
  });
  const { data: assignments = [] } = useListSupervisorAreasQuery({ branchId: selectedBranchId ?? undefined });

  const areaCountByEmployee = useMemo(() => {
    const counts = new Map();
    assignments.forEach((a) => {
      counts.set(a.employeeRecordGuid, (counts.get(a.employeeRecordGuid) || 0) + 1);
    });
    return counts;
  }, [assignments]);

  return (
    <MasterDetailListShell
      title="Supervisor Areas"
      filters={
        <input
          type="text"
          className="form-control form-control-sm"
          placeholder="Search supervisors..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      }
      isLoading={isLoading}
      emptyLabel="No supervisors match these filters."
      items={employees}
      getKey={(e) => e.recordGuid}
      resetKey={`${search}|${selectedBranchId}`}
      renderItem={(e) => {
        const isSelected = String(e.recordGuid) === String(selectedRecordGuid);
        const areaCount = areaCountByEmployee.get(e.recordGuid) || 0;
        return (
          <MasterDetailRow
            isSelected={isSelected}
            onClick={() => navigate(paths.guardingSupervisorAreaDetail(e.recordGuid))}
            avatarLabel={(e.empName || "?").trim().slice(0, 2).toUpperCase()}
            title={
              <>
                {e.empName} {e.empLastName}
                <span className="badge badge-linesuccess ms-2">Supervisor</span>
              </>
            }
            subtitle={<>{e.empCode} &middot; {e.branchCode}</>}
            badge={<span className="badge badge-lineinfo me-2">{areaCount} area{areaCount === 1 ? "" : "s"}</span>}
          />
        );
      }}
    />
  );
};

export default SupervisorCompactList;
